<template>
  <div>
    <div v-if="loading === true">
      <div class="centered">
        <a-spin />
      </div>
    </div>
    <form>
      <div class="row">
        <div class="col-md-12 col-lg-5">
          <label for="name" class="form-label">Supplier Name:</label>

          <input class="form-control" type="text" size="35" name="name" v-model="supplier.name" />

          <label for="contact" class="form-label">Main contact:</label>
          <input class="form-control" type="text" name="contact" v-model="supplier.contact" />

          <label for="accountnum" class="form-label">Account #:</label>
          <input class="form-control" type="text" name="accountnum" v-model="supplier.accountnum" />

          <label for="address1" class="form-label">Address 1:</label>
          <input class="form-control" type="text" name="address1" v-model="supplier.address1" />

          <label for="address2" class="form-label">Address 2:</label>
          <input class="form-control" type="text" name="address2" v-model="supplier.address2" />

          <label for="city" class="form-label">City:</label>
          <input class="form-control" type="text" name="city" v-model="supplier.city" />

          <label for="state" class="form-label">State:</label>
          <input class="form-control" type="text" name="state" v-model="supplier.state" />

          <label for="zip" class="form-label">Postal code:</label>
          <input class="form-control" type="text" name="zip" v-model="supplier.zip" />

          <label for="phone" class="form-label">Phone Number:</label>
          <input class="form-control" type="text" name="phone" v-model="supplier.phone" />

          <label for="fax" class="form-label">Fax Number:</label>
          <input class="form-control" type="text" name="fax" v-model="supplier.fax" />

          <label for="text" class="form-label">Email address:</label>
          <input class="form-control" type="text" name="email" v-model="supplier.email" />
        </div>

        <div class="col-md-12 col-lg-5">
          <div class="">
            <label class="form-check-label" for="giftcard">Manual Gift Card</label>

            <b-form-checkbox name="giftcard" size="lg" v-model="supplier.giftcard" :value="1" :unchecked-value="0" switch />
          </div>

          <div>
            <label class="form-check-label" for="amway">Amway Supplier</label>
            <b-form-checkbox name="giftcard" size="lg" v-model="supplier.amway" :value="true" :unchecked-value="false" switch />
          </div>
          <div class="mt-1">
            <label class="form-check-label" for="excdynamicvendor">Exclude Dynamic Vendor</label>

            <b-form-checkbox name="giftcard" size="lg" v-model="supplier.excdynamicvendor" :value="1" :unchecked-value="0" switch />
          </div>
          <div class="mt-1">
            <label class="form-check-label" for="showsuppaddprdinfo">Show Additional Product Info</label>

            <b-form-checkbox name="giftcard" size="lg" v-model="supplier.showsuppaddprdinfo" :value="1" :unchecked-value="0" switch />
          </div>
          <div class="mt-1">
            <label for="suppaddprdinfotitle" class="form-label">Show Additional Product Title:</label>
            <input class="form-control" type="text" name="suppaddprdinfotitle" v-model="supplier.suppaddprdinfotitle" />

            <label for="suppaddprdinfodesc" class="form-label">Show Additional Product Description:</label>
            <textarea class="form-control" name="suppaddprdinfodesc" rows="5" v-model="supplier.suppaddprdinfodesc"></textarea>
          </div>
        </div>
      </div>
    </form>
    <div class="row mt-2">
      <div class="col-md-12">
        <input v-if="this.$route.params.Id" type="submit" class="btn btn-primary" value="Update" @click="onUpdate" />
        <input v-else type="submit" class="btn btn-primary" value="Save" @click="onSubmit" />
      </div>
    </div>

    <div>
      <fieldset class="mt-4">
        <legend>Delete Supplier</legend>
        <form method="POST">
          <div class="row px-1">
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-label" for="comments">Why is this supplier being deleted?</label>
                <textarea cols="60" rows="5" name="comments" class="form-control"></textarea>
              </div>
              <div class="form-group mt-3">
                <input type="Submit" value="Delete this supplier" class="btn btn-danger" style="color: white;" @click="onDelete" />
              </div>
            </div>
          </div>
        </form>
      </fieldset>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: 'editSupplierForm',
  data() {
    return {
      loading: false,
      supplierId: this.$route.params.Id,
    };
  },
  methods: {
    onUpdate(e) {
      e.preventDefault();
      this.$store.dispatch('manageSuppliers/updateSupplier', this.supplier);
      this.$router.push({
        name: 'ManageSuppliers',
      });
    },
    onDelete(e) {
      e.preventDefault();
      this.$store.dispatch('manageSuppliers/removeSupplier', {
        supplierId: this.supplierId,
      });
      this.$router.push({
        name: 'ManageSuppliers',
      });
    },
  },

  //   (this.supplier = { ...this.supplier,id: this.supplierId,})

  computed: {
    supplier() {
      return this.$store.state.manageSuppliers.supplier;
    },
  },

  created() {
    window.scrollTo(0, 0);
    this.loading = true;
    if (this.$route.params.Id) {
      this.$store
        .dispatch('manageSuppliers/fetchSupplierById', {
          supplierId: this.supplierId,
        })
        .then(() => {
          this.loading = false;
        });
    }
  },
};
</script>
<style scoped>
form {
  border: 1px solid #ccc;
  padding: 20px;

  border-radius: 5px;
}

form label {
  font-size: 15px;
  font-weight: bold;
}

.form-label,
.form-check-label {
  margin-top: 10px;
}

.form-group {
  margin-bottom: 15px;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.checkbox {
  width: 3em;
  height: 1.3rem;
}

fieldset {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 1.4em;
  margin: 0 0 1.5em 0;
}

legend {
  position: absolute;
  font-size: 100%;
  width: auto;
  padding: 0px 5px;
  border: none;
  margin-top: -30px;
  font-weight: bold;
  background-color: white;
}

.centered {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 99999;
}
</style>